import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { APIReferenceRegistrationPage } from 'src/app/model/shared/api-reference-registration-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageVersionService } from 'src/app/service/page-version.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-api-reference-registration-page',
  templateUrl: './api-reference-registration-page.component.html',
  styleUrls: ['./api-reference-registration-page.component.scss']
})
export class ApiReferenceRegistrationPageComponent implements OnInit, OnDestroy {
  @Input() pageName = '';

  pageVersions: string[] = [];
  pageVersionServiceSubscription: any;
  apiReferenceRegistrationPage: APIReferenceRegistrationPage = {} as APIReferenceRegistrationPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private pageVersionService: PageVersionService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'api-reference-regisrtation') {
        this.apiReferenceRegistrationPage.htmlTitle = title.htmlTitle;
      }
    });
    const versionQuery = { 'fields.title': this.pageName, select: 'sys.id,fields.version' };

    this.contentfulService.getPageVersions(versionQuery).then((orderRetrieveItems) => {
      this.pageVersions = orderRetrieveItems
        .filter((item: { fields: undefined }) => item.fields !== undefined)
        .map((item: { fields: { version: string } }) => item.fields.version)
        .sort();

      let selectedPageVersion = '';
      if (this.pageVersions.length > 0) {
        selectedPageVersion = this.pageVersions[0];
        // console.log(this.pageName + ' >>>> default page version : ' + selectedPageVersion);
      }

      // console.log('default selectedPageVersion : ', selectedPageVersion);
      this.getPageContentFromContentful(selectedPageVersion);
    });

    this.pageVersionServiceSubscription = this.pageVersionService.pageVersion.subscribe((pageVersionData) => {
      if (pageVersionData.pageName === this.pageName && pageVersionData.selectedPageVersion !== undefined && pageVersionData.selectedPageVersion !== '') {
        // console.log('pageVersionData : ', pageVersionData);
        this.getPageContentFromContentful(pageVersionData.selectedPageVersion);
      }
    });
  }

  getPageContentFromContentful(selectedPageVersion: string) {
    // console.log(this.pageName + ' >>>> select page version : ' + selectedPageVersion);

    const query = selectedPageVersion === '' ? { 'fields.title': this.pageName } : { 'fields.title': this.pageName, 'fields.version': selectedPageVersion };
    this.contentfulService.getPageContentResponse(query).then((orderRetrievePageResponse) => {
      this.apiReferenceRegistrationPage.introductionSections = [];

      this.mapBanner(orderRetrievePageResponse.includes.Entry);
      this.apiReferenceRegistrationPage.banner.pageName = this.pageName;
      this.apiReferenceRegistrationPage.banner.pageVersions = this.pageVersions;
      this.apiReferenceRegistrationPage.banner.defaultPageVersion = selectedPageVersion;
      this.sharedDataService.addSharedData(this.apiReferenceRegistrationPage.banner);
      // console.log(this.pageName + ' >>>> >>>> banner.pageVersions : ' + this.apiReferenceRegistrationPage.banner.pageVersions);
      this.mapPageInfo(orderRetrievePageResponse.items);
      this.mapSection(orderRetrievePageResponse.includes.Entry);
      // console.log(this.apiReferenceRegistrationPage);
    });
  }

  private mapBanner(orderRetrieveBannerEntry: Entry<any>[]) {
    orderRetrieveBannerEntry
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.apiReferenceRegistrationPage.banner = {
      title: pageTitle,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.apiReferenceRegistrationPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.apiReferenceRegistrationPage.banner.url = entry.fields?.url;
      this.apiReferenceRegistrationPage.banner.editorEmail = editorDetails?.pop();
      this.apiReferenceRegistrationPage.banner.editorShortName = editorDetails?.pop();
      this.apiReferenceRegistrationPage.banner.editorFullName = editorDetails?.pop();
      this.apiReferenceRegistrationPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSection(apiReferenceRegistrationPage: Entry<any>[]) {
    apiReferenceRegistrationPage
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log(entry);

    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.apiReferenceRegistrationPage.introductionSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  ngOnDestroy() {
    this.pageVersionServiceSubscription.unsubscribe();
  }
}
